import { now, endOfMonth } from '../../../config/dayjsConfig'
import {
  CustomReportsActionTypes,
  CustomReportStore,
  SET_DATE,
  SET_ARGUMENTS,
  REMOVE_ARGUMENT,
  SET_ACTIVE_REPORT_ID
} from './types'
import { SET_CONTEXT_COMPANY } from '../company/types'

const initialState: CustomReportStore = {
  date: endOfMonth(now())
}

const customReportsReducer = (state = initialState, action: CustomReportsActionTypes) => {
  switch (action.type) {
    case SET_CONTEXT_COMPANY:
      return {
        ...initialState,
        date: state.date
      }
    case SET_DATE:
      return {
        ...state,
        date: action.payload
      }
    case SET_ARGUMENTS:
      return {
        ...state,
        arguments: action.payload
      }
    case REMOVE_ARGUMENT:
      return {
        ...state,
        arguments: state.arguments?.filter(arg => arg.id !== action.payload) || []
      }
    case SET_ACTIVE_REPORT_ID:
      if (action.payload === state.activeReportId) return state
      return {
        ...state,
        activeReportId: action.payload,
        arguments: undefined
      }
    default:
      return state
  }
}

export default customReportsReducer
